function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_azure") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.98,25.994c3.57-.726,6.518-1.327,6.552-1.335l.062-.015-3.37-4.615c-1.854-2.538-3.37-4.625-3.37-4.637s3.48-11.056,3.5-11.095c.007-.013,2.375,4.694,5.741,11.411l5.774,11.521.044.088-10.711,0-10.711,0Z",
    style: {
      fill: "#0089d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.125,24.586c0-.006,1.588-3.18,3.529-7.053l3.529-7.041L13.3,6.52c2.262-2.185,4.119-3.976,4.126-3.979a.914.914,0,0,1-.066.192L12.89,13.759,8.5,24.589l-3.189,0C3.56,24.6,2.125,24.593,2.125,24.586Z",
    style: {
      fill: "#0089d6"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.bd7495b3291b50ee9ee5bc81d06f002b.svg";
export { ForwardRef as ReactComponent };